module.exports = __webpack_public_path__ + "img/cinta2.53a12503.jpg";